import { createRoot } from "react-dom/client";
import App from "./app/App";
// @ts-ignore: CSS side-effect import
import "./styles/index.css";

const container = document.getElementById("root");
if (!container) throw new Error("Root element not found");
createRoot(container).render(<App />);
